import { useState } from 'react';
import ServerInfoView from './components/details/ServerInfoView';
import SchemasView from './components/details/SchemasView';
import UsersView from './components/details/UsersView';
import ReplicationView from './components/details/ReplicationView';
import InnoDbView from './components/details/InnoDbView';

const TABS = [
  { key: 'server-info', label: 'Server Info' },
  { key: 'schemas', label: 'Schemas' },
  { key: 'users', label: 'Users' },
  { key: 'replication', label: 'Replication' },
  { key: 'innodb', label: 'InnoDB' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

interface Props {
  serverId: string;
}

export default function DetailsTab({ serverId }: Props) {
  const [current, setCurrent] = useState<TabKey>('server-info');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 border-b border-slate-200 dark:border-slate-800">
        {TABS.map((t) => {
          const isActive = current === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setCurrent(t.key)}
              className={
                'px-3 py-1.5 text-sm rounded-t-md border-b-2 ' +
                (isActive
                  ? 'border-sky-500 text-slate-900 dark:text-slate-100'
                  : 'border-transparent text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200')
              }
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div className="pt-1">
        {current === 'server-info' && <ServerInfoView serverId={serverId} />}
        {current === 'schemas' && <SchemasView serverId={serverId} />}
        {current === 'users' && <UsersView serverId={serverId} />}
        {current === 'replication' && <ReplicationView serverId={serverId} />}
        {current === 'innodb' && <InnoDbView serverId={serverId} />}
      </div>
    </div>
  );
}
